import React from 'react';
import PropTypes from 'prop-types';
import ConnectedReport from './ConnectedReport';

function ReportRouting({ match }) {
  return <ConnectedReport />;
}

ReportRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default ReportRouting;
